// Dimensions
export const X = 0
export const Y = 1
export const Z = 2
export const ROTATION = 3
export const OPACITY = 4

export const TIME = 2

export const SKEW = 0
export const STRETCH = 1
export const FRICTION = 2
export const TIMER_INTERVAL = 3

export const DIMENSION_LABELS = ['X', 'Y', 'Z', 'Rotation', 'Opacity']
export const OUTPUT_OPTIONS_LABELS = ['X', 'Y', 'Time']
export const SIMULATION_OPTIONS_LABELS = ['Skew (1/0)', 'Stretch (1/0)', 'Friction (%)', 'Timer interval (ms)']
